'use strict';

import moment from 'moment';


export const toRelativeDate = d => d && moment(d).fromNow();

//=================================================================================================================

export const toShortDate = d => d && moment(d).format('L');

//=================================================================================================================

export const toSimpleDate = d => d && moment(d).format('LL');

//=================================================================================================================

export const toAbsoluteDate = d => d && moment(d).format('LLLL');
